import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    class: "matrix-grid",
    style: _normalizeStyle({
      gridTemplateColumns: 'repeat(' + $props.size + ', 38px)'
    })
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.normalized, (row, ri) => {
    return _openBlock(), _createElementBlock(_Fragment, {
      key: 'r_' + ri
    }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row, (cell, ci) => {
      return _openBlock(), _createElementBlock("div", {
        key: 'c_' + ri + '_' + ci,
        class: "matrix-cell",
        style: _normalizeStyle({
          backgroundColor: Number(cell) === 1 ? $props.fillColor : '#ffffff'
        })
      }, null, 4);
    }), 128))], 64);
  }), 128))], 4);
}